import { render, staticRenderFns } from "./canadalist.vue?vue&type=template&id=bf68ad88"
import script from "./canadalist.vue?vue&type=script&lang=js"
export * from "./canadalist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports